export default import.meta.ROLLDOWN_FILE_URL_B45gGOH7VkhJBQ5AptProw